/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";
export const Gears = React.forwardRef<
  SVGSVGElement,
  Omit<React.SVGProps<SVGSVGElement>, "css">
>((props, ref) => (
  <svg viewBox="0 0 121.5 121.5" ref={ref} {...props}>
    <style>
      {
        ".st0{fill:#d9cfff}.st3{fill:#fff}.st7{fill:#3f20ba}.st10,.st11{fill:none;stroke:#3f20ba;stroke-width:.75;stroke-linejoin:round;stroke-miterlimit:10}.st11{stroke-width:1.2}"
      }
    </style>
    <g id="Layer_1">
      <path
        d="M110.42 34.62v-6.84c-.98-1.35-2.25-2.61-3.77-3.76l-7.28 1.66c-.76-.47-1.6-.91-2.48-1.31.06.03.12.05.18.08v-5.17h-.21c-2.21-.66-4.58-1.17-7.07-1.49l-3.72 3.97c-.87-.06-1.76-.1-2.67-.1-.92 0-1.82.04-2.71.1l-3.68-3.98c-2.49.32-4.87.82-7.07 1.49h-.21v5.17c.06-.03.12-.05.18-.08-.06.03-.12.05-.18.08v-.01h-.01v.01c-.82.38-1.6.79-2.32 1.24L60.15 24c-1.52 1.15-2.8 2.41-3.77 3.76v6.84l-2.21.42v8.9c.12 1.48.8 2.92 1.54 4.28l6.16-.1v6.49l5.77-2.89 1.2-.48 7.44 3.92c.54.12 1.12.22 1.76.31l1.6 4.46c1.23.09 2.49.14 3.76.14 1.28 0 2.53-.05 3.77-.14l1.63-4.46c1.77-.24 2.98-.59 4.55-1.06l5.82 3c2.13-.79 4.07-1.72 5.77-2.79v-6.49l6.15.1c.74-1.36 1.43-2.8 1.54-4.28v-8.9l-2.21-.41zM83.4 42.8c-8.16 0-14.77-3.82-14.77-8.52s6.61-8.52 14.77-8.52 14.77 3.82 14.77 8.52-6.62 8.52-14.77 8.52z"
        className="st3"
      />
      <path
        d="M76.27 55.15c.54.12 1.12.22 1.76.31l1.6 4.46v-8.9l-1.11-4.46c-1.77-.23-3.46-.59-5.04-1.06l-5.85 3v3.22l1.2-.48 7.44 3.91zM70.82 38.72c2.6-2.44 7.25-4.07 12.58-4.07s9.98 1.63 12.58 4.07c1.38-1.3 2.19-2.82 2.19-4.45 0-4.71-6.61-8.52-14.77-8.52s-14.77 3.82-14.77 8.52c0 1.63.81 3.15 2.19 4.45zM88.79 55.46l-1.63 4.46v-8.9l1.14-4.46c1.77-.24 3.46-.59 5.04-1.06l5.82 3v8.9l-5.82-3c-1.57.46-2.78.82-4.55 1.06zM104.93 45.7l-4.1-3.85c1.07-.82 1.97-1.71 2.67-2.67l7.58.13v8.9l-6.16-.1V45.7zM61.86 48.12V45.7l4.11-3.83c-1.08-.82-1.98-1.72-2.69-2.68l-7.58.13v8.9l6.16-.1zM104.28 30.58c.51.97.83 1.99.93 3.04l5.21 1v-6.84l-6.14 2.8zM61.58 33.62c.09-1.05.41-2.07.92-3.04l-6.13-2.81v6.84l5.21-.99zM97.07 24.45v-5.18h-.21l-1.61 4.41c.63.24 1.24.5 1.82.77zM69.93 19.27l1.57 4.42c-.62.23-1.22.48-1.79.75l.01.01v-5.18h.21z"
        className="st0"
      />
      <path
        d="M99.16 48.5v8.9M111.09 39.32v8.9M97.07 19.27v5.18M69.72 19.27v5.19M55.7 39.32v8.9M67.63 48.5v3.21M63.28 39.19v5.16M73.48 45.5v7.95M78.27 46.56v8.9M88.55 46.55v8.91M93.34 45.49v8.9M103.51 39.19v5.17"
        className="st10"
      />
      <ellipse cx={83.4} cy={34.27} className="st11" rx={14.77} ry={8.52} />
      <path
        d="M112.63 35.04c-.12 1.48-.8 2.92-1.54 4.28l-7.58-.13c-.7.96-1.6 1.85-2.67 2.67l4.1 3.85c-1.7 1.07-3.64 2.01-5.77 2.79l-5.82-3c-1.58.47-3.27.83-5.04 1.06l-1.34 4.46c-1.23.09-2.29.14-3.57.14-1.28 0-2.34-.05-3.57-.14l-1.31-4.46c-1.77-.23-3.46-.59-5.04-1.06l-5.85 3c-2.13-.79-4.07-1.72-5.77-2.79l4.11-3.83c-1.08-.82-1.98-1.72-2.69-2.68l-7.58.13c-.74-1.36-1.42-2.8-1.54-4.28l7.42-1.42c.09-1.05.41-2.07.92-3.04l-6.13-2.81c.98-1.35 2.25-2.61 3.77-3.76l7.25 1.68c1.22-.76 2.6-1.43 4.11-1.99l-1.57-4.42c2.21-.66 4.58-1.17 7.07-1.49l3.68 3.98c.89-.06 1.79-.1 2.71-.1.9 0 1.79.04 2.67.1l3.72-3.97c2.49.32 4.87.82 7.07 1.49l-1.61 4.41c1.51.57 2.89 1.23 4.12 1.99l7.28-1.66c1.52 1.15 2.8 2.41 3.77 3.76l-6.13 2.8c.51.97.83 1.99.93 3.04l7.42 1.4z"
        className="st11"
      />
      <path
        d="M70.82 38.72c2.6-2.44 7.25-4.07 12.58-4.07s9.98 1.63 12.58 4.07c1.38-1.3 2.19-2.82 2.19-4.45 0-4.71-6.61-8.52-14.77-8.52s-14.77 3.82-14.77 8.52c0 1.63.81 3.15 2.19 4.45zM110.42 27.78v6.84M56.38 27.77v6.85M61.86 48.12l-6.16.1c-.74-1.36-1.42-2.8-1.54-4.28v-8.9M61.86 54.61V45.7M104.93 45.7v8.9c-1.7 1.07-3.64 2.01-5.77 2.79l-5.82-3c-1.58.47-2.78.83-4.55 1.06l-1.63 4.46c-1.23.09-2.49.14-3.77.14-1.28 0-2.53-.05-3.76-.14l-1.6-4.46c-.65-.09-1.22-.19-1.76-.31"
        className="st11"
      />
      <path
        d="M112.63 35.04v8.9c-.12 1.48-.8 2.92-1.54 4.28l-6.16-.1"
        className="st11"
      />
      <path d="M87.16 51.02v8.9M79.63 51.02v8.9" className="st10" />
      <g>
        <path
          d="M82.24 60.06l.38-4.23.37 4.23zM80.69 60.06l.37-4.23.38 4.23zM83.8 60.06l.37-4.23.38 4.23zM85.35 60.06l.38-4.23.37 4.23z"
          className="st7"
        />
      </g>
      <g>
        <path
          d="M100.13 56.79l.38-4.24.37 4.24zM101.59 56.13l.37-4.24.38 4.24zM103.05 55.29l.37-4.24.38 4.24z"
          className="st7"
        />
      </g>
      <g>
        <path
          d="M64.45 53.24l.38-1.35.37 1.35zM62.99 54l.38-2.95.37 2.95z"
          className="st7"
        />
      </g>
      <g>
        <path
          d="M56.79 48.22l.37-3.4.38 3.4zM58.24 48.22l.38-3.4.37 3.4zM59.7 48.22l.38-3.4.37 3.4z"
          className="st7"
        />
      </g>
      <g>
        <path
          d="M106.34 48.22l.37-3.4.38 3.4zM107.8 48.22l.37-3.4.38 3.4zM109.25 48.22l.38-3.4.37 3.4z"
          className="st7"
        />
      </g>
      <g>
        <path
          d="M83.4 30.75l.37 3.9h-.75zM85.34 29.27l.37 5.45h-.75zM87.28 31.05l.38 3.9h-.75zM77.56 29.89l.38 5.46h-.75zM79.51 31.05l.37 3.9h-.75zM81.45 29.27l.38 5.45h-.75zM71.73 34.06l.38 3.91h-.75zM73.68 31.31l.37 5.47h-.75zM75.62 32.03l.38 3.92h-.75zM89.23 29.89l.37 5.46h-.75zM91.17 32.03l.37 3.92h-.75zM93.11 31.31l.38 5.47h-.75zM95.06 34.06l.37 3.91h-.75z"
          className="st7"
        />
      </g>
      <g>
        <path fill="#09d900" d="M97.08 24.45h-.01z" />
      </g>
      <g>
        <path d="M47.63 63.86l.37 6.65h-.75z" className="st7" />
      </g>
      <g>
        <path d="M45.69 61.49l.37 9.08h-.75z" className="st7" />
      </g>
      <g>
        <path d="M49.57 61.49l.38 9.08h-.75z" className="st7" />
      </g>
      <g>
        <path d="M43.74 64.09l.38 6.64h-.75z" className="st7" />
      </g>
      <g>
        <path d="M51.52 64.09l.37 6.64h-.75z" className="st7" />
      </g>
      <g>
        <path
          d="M86.39 69.04c-.15-1.97-.74-3.87-1.72-5.67l-8.48.14v-8.6c-2.26-1.42-4.83-2.66-7.65-3.7l-7.72 3.98c-2.09-.62-4.33-1.1-6.68-1.41l-1.52-5.92c-1.64-.12-3.3-.19-4.99-.19-1.69 0-3.36.07-4.99.19l-1.48 5.91c-2.35.31-4.59.78-6.68 1.4l-7.76-3.97c-2.82 1.04-5.39 2.29-7.65 3.7v8.6l-8.48-.14c-.98 1.8-1.57 3.71-1.72 5.67v11.8l2.93.56v9.07c1.29 1.79 2.98 3.46 5 4.98l9.61-2.22c1.04.64 2.16 1.24 3.36 1.78v6.73c2.93.88 6.07 1.55 9.38 1.97l4.88-5.27c.59.04 1.18.08 1.78.1s1.2.03 1.81.03c1.2 0 2.38-.05 3.54-.13l4.94 5.27c3.31-.43 6.45-1.09 9.38-1.97V95c.59-.27 1.17-.55 1.72-.84s1.09-.6 1.6-.92l9.65 2.2c2.02-1.52 3.71-3.19 5-4.99V81.4l2.93-.56.01-11.8zM47.63 81.36c-10.81 0-19.58-5.06-19.58-11.3 0-6.24 8.77-11.3 19.58-11.3s19.58 5.06 19.58 11.3c0 6.24-8.77 11.3-19.58 11.3z"
          className="st3"
        />
        <path
          d="M24.53 59.98c-1.43 1.09-2.63 2.28-3.56 3.55l-1.89-.03v-8.6l5.45 5.08zM74.3 63.53c-.93-1.27-2.13-2.45-3.54-3.54l5.43-5.1v8.6l-1.89.04zM77.28 70.79v5.06l6.17 2.82v2.73l2.94-.56v-11.8zM76.55 70.93c-.12 1.39-.55 2.74-1.23 4.03l1.96.89v-5.06l-.73.14zM8.87 69.04v11.8l2.94.56v-2.73l6.17-2.82v-5.07zM18.71 70.92l-.73-.14v5.07l1.96-.89c-.69-1.3-1.11-2.65-1.23-4.04zM16.81 83.66v11.8l9.61-2.23v-11.8zM26.42 81.43v11.8c1.04.64 2.16 1.24 3.36 1.78v-5.08l2.08-5.87c-1.99-.74-3.82-1.62-5.44-2.63zM63.35 84.09l2.13 5.85v5.07c1.19-.54 2.3-1.13 3.33-1.76v-11.8c-1.62 1-3.46 1.89-5.46 2.64zM68.81 81.45v11.8l9.64 2.21V83.65zM51.16 86.64v11.8l4.94 5.27v-11.8zM39.16 91.91v11.8l4.88-5.27v-11.8z"
          className="st0"
        />
        <path
          d="M47.63 86.77c-1.22 0-2.41-.05-3.59-.13v11.8c1.18.08 2.37.13 3.59.13 1.2 0 2.38-.05 3.54-.13v-11.8c-1.16.08-2.34.13-3.54.13zM31.02 75.89c3.43-3.22 9.58-5.38 16.61-5.38s13.18 2.16 16.61 5.38c1.82-1.71 2.89-3.72 2.89-5.88 0-6.22-8.73-11.26-19.5-11.26s-19.5 5.04-19.5 11.26c-.01 2.16 1.06 4.17 2.89 5.88z"
          className="st0"
        />
        <ellipse cx={47.63} cy={70.06} className="st11" rx={19.58} ry={11.3} />
        <path
          d="M86.39 69.04c-.15-1.97-.74-3.87-1.72-5.67l-10.37.16c-.93-1.27-2.13-2.45-3.54-3.54l5.43-5.1c-2.26-1.42-4.83-2.66-7.65-3.7l-7.72 3.98c-2.09-.62-4.33-1.1-6.68-1.41l-1.52-5.92c-1.64-.12-3.3-.19-4.99-.19-1.69 0-3.36.07-4.99.19l-1.48 5.91c-2.35.31-4.59.78-6.68 1.4l-7.76-3.97c-2.82 1.04-5.39 2.29-7.65 3.7l5.45 5.08c-1.43 1.09-2.63 2.28-3.56 3.55l-10.37-.17c-.98 1.8-1.57 3.71-1.72 5.67l9.84 1.88c.12 1.4.55 2.75 1.23 4.03l-8.13 3.72c1.29 1.79 2.98 3.46 5 4.98l9.61-2.22c1.62 1 3.45 1.89 5.45 2.64l-2.08 5.87c2.93.88 6.07 1.55 9.38 1.97l4.88-5.27c1.18.08 2.37.13 3.59.13 1.2 0 2.38-.05 3.54-.13l4.94 5.27c3.31-.43 6.45-1.09 9.38-1.97l-2.13-5.85c2-.75 3.84-1.64 5.46-2.64l9.65 2.2c2.02-1.52 3.71-3.19 5-4.99l-8.13-3.71c.68-1.28 1.1-2.63 1.23-4.03l9.81-1.85z"
          className="st11"
        />
        <path
          fill="none"
          stroke="#3f20ba"
          strokeLinejoin="round"
          strokeMiterlimit={10}
          strokeWidth={1.35}
          d="M30.95 75.89c3.44-3.22 9.61-5.38 16.68-5.38s13.23 2.16 16.68 5.38c1.83-1.71 2.9-3.72 2.9-5.88 0-6.22-8.77-11.26-19.58-11.26S28.05 63.8 28.05 70.01c0 2.16 1.07 4.17 2.9 5.88z"
        />
        <path
          d="M19.08 54.9v8.6M76.18 54.9v8.6M11.81 78.67v11.8c1.29 1.79 2.98 3.46 5 4.98l9.61-2.22c1.04.64 2.16 1.24 3.36 1.78M29.78 89.94v11.8c2.93.88 6.07 1.55 9.38 1.97l4.88-5.27c1.18.08 2.37.13 3.59.13"
          className="st11"
        />
        <path
          d="M47.63 98.57c1.2 0 2.38-.05 3.54-.13l4.94 5.27c3.31-.43 6.45-1.09 9.38-1.97v-11.8"
          className="st11"
        />
        <path
          d="M65.48 95.01c1.19-.54 2.3-1.13 3.33-1.76l9.65 2.2c2.02-1.52 3.71-3.19 5-4.99v-11.8"
          className="st11"
        />
        <path
          d="M83.45 81.4l2.94-.56v-11.8M8.87 69.04v11.8l2.94.56"
          className="st11"
        />
        <path
          d="M71.99 89.95l.38 4.03h-.75zM70.53 87.68l.38 5.97h-.75zM74.91 90.62l.37 4.03h-.75zM73.45 88.34l.37 5.97h-.75zM76.36 89.01l.38 5.97h-.75zM24.73 87.65l.37 5.97h-.75zM23.27 89.93l.37 4.03h-.75zM21.81 88.33l.38 5.97h-.75zM20.35 90.61l.38 4.03h-.75zM18.9 89l.37 5.97h-.75zM37.39 97.48l.37 5.97h-.75zM35.93 99.17l.37 4.03h-.75zM40.59 98.27l.37 4.02h-.75zM41.8 96.81l.38 4.02h-.75zM43.02 95.35l.37 4.03h-.75zM54.74 98.27l.37 4.02h-.75zM53.52 96.81l.38 4.02h-.75zM52.31 95.35l.37 4.03h-.75zM34.47 96.95l.38 5.97h-.75zM33.01 98.56l.38 4.03h-.75zM31.56 96.26l.37 5.97h-.75zM63.71 96.26l.37 5.97h-.75zM62.25 98.56l.37 4.03h-.75zM60.79 96.95l.38 5.97h-.75zM59.33 99.17l.38 4.03h-.75zM57.88 97.48l.37 5.97h-.75zM65.12 67.67l.38 7.37h-.75zM57.35 62.92l.37 9.08h-.75zM53.46 61.95l.38 9.08h-.75zM55.4 64.79l.38 6.65h-.75zM61.24 64.61l.37 9.08h-.75z"
          className="st7"
        />
        <g>
          <path d="M59.29 66.08l.38 6.66h-.75z" className="st7" />
        </g>
        <g>
          <path d="M63.18 68.3l.37 6.65h-.75z" className="st7" />
        </g>
        <g>
          <path d="M32.08 68.3l.37 6.65h-.75z" className="st7" />
        </g>
        <g>
          <path d="M30.14 67.67l.37 7.37h-.75z" className="st7" />
        </g>
        <g>
          <path d="M34.02 64.61l.38 9.08h-.75z" className="st7" />
        </g>
        <g>
          <path d="M35.97 66.09l.37 6.65h-.75z" className="st7" />
        </g>
        <g>
          <path d="M39.85 64.79l.38 6.65h-.75z" className="st7" />
        </g>
        <g>
          <path d="M37.91 62.92l.38 9.08h-.75z" className="st7" />
        </g>
        <g>
          <path d="M41.8 61.95l.37 9.08h-.75z" className="st7" />
        </g>
        <g>
          <path d="M46.92 94.55l.38 4.02h-.75z" className="st7" />
        </g>
        <g>
          <path d="M48.33 94.55l.38 4.02h-.75z" className="st7" />
        </g>
        <g>
          <path d="M49.74 94.55l.38 4.02h-.75z" className="st7" />
        </g>
        <g>
          <path d="M45.51 94.55l.38 4.02h-.75z" className="st7" />
        </g>
        <g>
          <path d="M67.24 90.15l.38 4.03h-.75z" className="st7" />
        </g>
        <g>
          <path d="M28 90.15l.37 4.03h-.75z" className="st7" />
        </g>
        <g>
          <path d="M79.98 90.19l.38 4.03h-.75z" className="st7" />
        </g>
        <g>
          <path d="M81.05 89.22l.38 4.03h-.75z" className="st7" />
        </g>
        <g>
          <path d="M82.12 88.05l.37 4.03h-.75z" className="st7" />
        </g>
        <g>
          <path d="M15.28 90.19l.37 4.03h-.75z" className="st7" />
        </g>
        <g>
          <path d="M14.21 89.22l.38 4.03h-.75z" className="st7" />
        </g>
        <g>
          <path d="M13.14 88.05l.38 4.03h-.75z" className="st7" />
        </g>
        <g>
          <path
            d="M39.16 91.91v11.8M16.81 83.66v11.8M56.1 91.91v11.8M77.28 70.93v4.63M17.98 70.92v4.64M26.42 81.43v11.8M68.81 81.45v11.8M44.04 86.64v11.8M51.16 86.64v11.8M78.45 83.65v11.81"
            className="st10"
          />
        </g>
        <g>
          <path
            d="M47.6 63.77l.38 6.66h-.75zM45.66 61.4l.38 9.09h-.75zM49.55 61.4l.37 9.09h-.75zM43.72 64l.37 6.65h-.75zM51.49 64l.38 6.65h-.75z"
            className="st7"
          />
        </g>
      </g>
      <g>
        <path d="M74.36 54l.38-2.93.37 2.93z" className="st7" />
      </g>
      <g>
        <path d="M75.48 54.55l.37-3.17.38 3.17z" className="st7" />
      </g>
      <g>
        <path d="M76.59 55.25l.38-3.54.37 3.54z" className="st7" />
      </g>
      <g>
        <path d="M71.81 52.56l.37-3.5.38 3.5z" className="st7" />
      </g>
      <g>
        <path d="M70.44 52.17l.38-2.19.37 2.19z" className="st7" />
      </g>
    </g>
  </svg>
));
